// @flow

// Public Holidays 2019 - 2020 UK, incl NI, Scotland
//
// This is a temporary for demostrating the feature and until we can determine a
// clear path forward on how to provide public holidays dates on a per country /
// employee basis.

export const isBankHoliday = (date: string, dates: Array<string>): boolean => {
  return dates.indexOf(new Date(date).toISOString().substring(0, 10)) !== -1;
};
